import styled from 'foundations-theming/utils';
export const EditCellContentAndValidationAlertWrapper = styled.div.withConfig({
  displayName: "StyledEditCellComponents__EditCellContentAndValidationAlertWrapper",
  componentId: "sc-1mtos77-0"
})(["display:flex;align-items:center;justify-content:space-between;"]);
export const PropertyCellDisplayContentIndicatorsWrapper = styled.span.withConfig({
  displayName: "StyledEditCellComponents__PropertyCellDisplayContentIndicatorsWrapper",
  componentId: "sc-1mtos77-1"
})(["align-items:center;display:inline-flex;gap:", ";"], ({
  theme
}) => theme.space['200']);